(ns teamoesterreich.admin-mode.data.eventAlarm
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn serialize-path [in]
  (json/serialize in))


(defn get-alarm-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm")
                  (fn [r-list status]
                    (if (= status 200)
                      (done-fn (into {} (map (fn [e] [(get e "eventAlarm-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list)))))
                      (done-fn {})))))


(defn <alarm-load [uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid)
                  (fn [r-list status]
                    ;(log/debug "event-list-get-event-details done" r-list status)
                    (when (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))))))



(defn >alarm-save [uuid data done-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid)
                  (ajax/serialize data)
                  (fn [r-list status]
                    (log/debug ">alarm-save done" r-list status)
                    (if (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                      (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                               )))))

(defn >alarm-delete [uuid done-fn]
  (ajax/auth-delete> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid)
                     (fn [body status]
                       (log/debug ">alarm-delete done" body status)
                       (if (= status 200)
                         (done-fn body)
                         (done-fn {:error (str "Fehler beim Löschen " status)})))))

(defn >alarm-send-alarm [uuid]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid "/send-alarm")
                  (fn [r-list status]
                    (log/debug ">alarm-send-alarm done" r-list status))))

(defn >member-action [uuid action member-tomIds done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid "/member-action?action=" action "&")
                   (ajax/serialize member-tomIds)
                   (fn [r-list status]
                     (log/debug ">alarm-send-alarm done" r-list status)
                     (done-fn))))

(defn >alarm-send-test-push [uuid tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid "/send-test-push?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug ">alarm-send-test-alarm done" r-list status))))

(defn >alarm-send-test-sms [uuid tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid "/send-test-sms?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug ">alarm-send-test-sms done" r-list status))))

(defn >alarm-send-test-email [uuid tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid "/send-test-email?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug ">alarm-send-test-email done" r-list status))))



(defn alarm-update [& [on-finished]]
  (let [uuid (get-in @v-state/app-state [:selected-alarm :eventAlarm-uuid])]
    (<alarm-load uuid (fn [response]
                        (swap! v-state/app-state assoc :selected-alarm response)
                        (when on-finished (on-finished))
                        ))))




(defn >new-alarm [name done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm")
                   (ajax/serialize {:eventAlarm-active true
                                    :eventAlarm-status "prepare"
                                    :eventAlarm-orgId  (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC))
                                    :eventAlarm-name   (str name)})
                   (fn [r-list status]
                     ;(log/debug "event-list-get-event-details done" r-list status)
                     (if (= status 200)
                       (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                       (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                                )))))





(defn >alarm-add-event [uuid event-uuid done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid "/add-event")
                   (ajax/serialize {:event-uuid event-uuid})
                   (fn [b status]
                     (done-fn)
                     (log/debug ">alarm-add-event done" b status))))

(defn >alarm-remove-event [uuid event-uuid done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event-alarm/" uuid "/rm-event")
                   (ajax/serialize {:event-uuid event-uuid})
                   (fn [b status]
                     (done-fn)
                     (log/debug ">alarm-remove-event done" b status))))











